export enum FileSizeType {
  MB = 1048576, // 1024 * 1024
  KB = 1024, // 1024
}

export enum FileSizeValue {
  KB = 'KB',
  MB = 'MB',
}
